<template>
    <div id="preorderschildrensroot">
        <vs-table
            ref="table" 
            :data="listProductPreOrders"
            noDataText="Sem dados disponíveis"
            id="tableDataOfPreOrderProducts"
            style="padding: 0 !important;"
        >
            <template slot="thead">
                <vs-th class="text-base" sort-key="image" v-if="!isService">
                    Imagem
                </vs-th>
                <vs-th class="text-base" sort-key="name" style="width:150px;">
                    Nome
                </vs-th>
                <vs-th class="text-base p-0" style="width: 100px;" sort-key="discount_price">
                    Preço com Desconto
                </vs-th>
                <vs-th class="text-base" sort-key="price">
                    Preço
                </vs-th>
               <vs-th class="text-base" sort-key="amount" v-if="!isService">
                   Quantidade
               </vs-th>
               <vs-th class="text-base" sort-key="category" v-if="isService">
                   Categoria
               </vs-th>
            </template>
            <template slot-scope="{data}">
                <tbody>
                    <vs-tr 
                        :data="tr" 
                        :key="tr.id"
                        :id="tr.id"
                        v-for="(tr, index) in data"
                    >
                        <vs-td :data="tr.image" v-if="!isService">
                            <div class="d-flex flex-row items-center justify-around">
                                <img v-if="tr.product.image !== undefined && tr.image !== '' && tr.image != null" :src="tr.image" style="width: 50px !important; height: 50px !important;">
                                <img v-else src="@/assets/images/products/product_without_photo.png" style="width: 40px !important; height: 40px !important;">
                            </div>
                        </vs-td>

                        <vs-td :data="isService ? tr.name : tr.product.name">
                            <div class="d-flex flex-row items-center justify-around">
                                <p class="text-center">
                                    {{ isService ? tr.name : tr.product.name }}
                                </p>
                            </div>
                        </vs-td>

                        <vs-td class="pl-1" v-if="isService">
                            <p style="font-size: 13px;">
                                <strong>R$ {{ ((tr.discount_price).toFixed(2)).replace('.', ',')  }}</strong>
                            </p>
                        </vs-td>

                        <vs-td class="pl-1" v-if="!isService">
                            <p style="font-size: 13px;">
                                <strong>R$ {{ ((tr.discount_price * tr.quantity).toFixed(2)).replace('.', ',')  }}</strong>
                            </p>
                        </vs-td>

                        <vs-td v-if="!isService">
                            <p style="font-size: 13px;" >
                                <strong>R$ {{ ((tr.product.price * tr.quantity).toFixed(2)).replace('.', ',')  }}</strong>
                            </p>
                        </vs-td>

                        <vs-td v-if="isService">
                            <p style="font-size: 13px;" >
                                <strong>R$ {{ (tr.price).toFixed(2).replace('.', ',')  }}</strong>
                            </p>
                        </vs-td>

                        <vs-td v-if="!isService">
                            <p style="font-size: 13px;">
                                Qtde <strong style="color: #1196e1;"> {{ tr.quantity }} </strong>
                            </p>
                        </vs-td>

                        <vs-td v-if="isService">
                            <p style="font-size: 13px;">
                                {{ tr.category }}
                            </p>
                        </vs-td>
                    </vs-tr>
                </tbody>
            </template>
        </vs-table>
    </div>
</template>

<script>
    import orderProduct from "@/http/requests/orderProduct";
    
    export default {
        
        props: {
            idPreOrder: {
                type: Number,
                required: true
            },
            isService: {
                type: Boolean,
                required: true
            },
            services: {
                type: Array|Object|null,
                required: true
            },
        },
        data() {
            return {
                listProductPreOrders: []
            }
        },
        methods: {
            async fetchProductPreOrders() {
                const idPreOrder = await this.idPreOrder;
                
                if (!this.isService) {
                    await orderProduct.fetch(idPreOrder)
                    .then((response) => {
                        const parsedData = response.data.data.getOrderProduct;
                        
                        this.listProductPreOrders = parsedData;
                    })
                    .catch((exception) => {
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Ocorreu um erro ao consultar os produtos!',
                            text: 'Erro ao consultar os produtos, por favor nos contate para corrigir-mos!'
                        });
                        console.log(exception)
                    });
                }
                else {
                    this.listProductPreOrders = this.services;
                }          
            },
        },
        async mounted() {
            await this.fetchProductPreOrders()
        }
    }
</script>

<style lang="scss">
    .vs-col.vs-xs-12.vs-sm-6.vs-lg-9 {
        width: 63% !important;
    }
    #preorderschildrensroot {
        #tableDataOfPreOrderProducts {
            .vs-con-tbody.vs-table--tbody {
                background-color: transparent !important;
                border: 0 !important; 
            }
            .con-tablex.vs-table--content {
                width: 100%;
            }
            table.vs-table.vs-table--tbody-table {
                border-collapse: separate;
                border-spacing: 0 0.5rem;
                padding: 0 1rem;
            }
            header {
                float: left;
                margin-left: 16px;
            }
            tbody {
                tr {
                    border-radius: 20px !important;
                    height: 45px;
                    box-shadow: none;
                    td {
                        padding: 0px;
                        border-style: solid; 
                        border-color: #b6bebd6e;
                    }
                    td:first-of-type {
                        border-top-left-radius: 25px !important; 
                        border-bottom-left-radius: 25px !important; 
                        border-width: 1px 0px 1px 1px !important;    
                    }
                    td:last-of-type {
                        border-top-right-radius: 25px !important; 
                        border-bottom-right-radius: 25px !important; 
                        border-width: 1px 1px 1px 0px !important; 
                    }
                    td:nth-of-type(2), td:nth-of-type(3), td:nth-of-type(4) {
                        border-width: 1px 0px 1px 0px !important; 
                    }
                }
            }
        }
    }
</style>